export async function postFormData(formData) {
  const apiUrl = 'https://api.britalbgroup.com/submit-form';
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
  if (!response.ok) {
    throw new Error('Failed to submit form data');
  }
  return response.json();
}
